import { h, FunctionComponent } from 'preact'
import classnames from 'classnames'
import { ButtonProps } from './type'

import classes from './button.scss'

const Button: FunctionComponent<ButtonProps> = (props) => {
  const { fullWidth = true, className = '', type = 'primary', children, disabled, persistClick, ...others } = props

  const classNames = classnames(classes.xmButton, className, {
    [classes.fullWidth]: fullWidth,
    [classes.primary]: type === 'primary',
    [classes.secondary]: type === 'secondary',
    [classes.disabled]: disabled,
  })

  return (
    <button type="button" disabled={disabled && !persistClick} className={classNames} {...others}>
      {children}
    </button>
  )
}

export default Button
